import React, { Component } from "react";
import MaterialTable from "material-table";
import UiUtils from "../../../provider/UiUtils";
import PtsAlert from "../../givBee/ptsAlert/PtsAlert";
import { withRouter } from "../../../withRouter";
import store from "../../../redux/store";
// import "./RoleManagementList.css";
import Utils from "../../../provider/Utils";
import ApplicationStateAction from "../../../redux/applicationState/ApplicationStateAction";
import PtsButton from "../../givBee/buttons/PtsButton";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import { ApProfileMsGetList_Url } from "../../../provider/ServiceUrl";
class ProfileManagementList extends Component {
  header = store.getState().adminHeader.adminHeader;
  profileState = store.getState().applicationState.profileState;
  profileStateDetails = {};
  title = "Profile Management List";
  breadCrumb = [{ pageid: "", uiname: "Profile Management List" }];
  constructor() {
    super();
    if (this.profileState) {
      this.profileStateDetails = Object.getOwnPropertyNames(this.profileState);
    }
    if (this.profileStateDetails.length > 0) {
      this.state = {
        initialPage: this.profileState.initialPage,
        pageSize: this.profileState.pageSize,
        profileId: this.profileState.profileId,
        searchText: this.profileState.searchText,
        profileList: [],
        menus: [],
        render: false,
        getCreatePermission: false,
        getUpdatePermission: false,
        getDeletePermission: false,
      };
    } else {
      this.state = {
        searchText: "",
        initialPage: 0,
        pageSize: 20,
        profileList: [],
        menus: [],
        profileId: 0,
        render: false,
        getCreatePermission: false,
        getUpdatePermission: false,
        getDeletePermission: false,
      };
    }
    this.getprofileManagementList();
  }
  getprofileManagementList() {
    const postObject = {
      header: this.header,
    };
    AdminFetchServerData.callPostService(
      ApProfileMsGetList_Url,
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let profileList = output.data.profileList;
        let getPermission = Utils.getRolePermission(output.data.privilegeList);
        let getCreatePermission = getPermission[1];
        let getUpdatePermission = getPermission[3];
        let getDeletePermission = getPermission[4];
        let isPaging = false;
        if (profileList.length > this.state.pageSize) {
          isPaging = true;
        }
        this.setState({
          render: true,
          profileList: profileList,
          isPaging: isPaging,
          initialPage: this.state.initialPage,
          getCreatePermission: getCreatePermission,
          getUpdatePermission: getUpdatePermission,
          getDeletePermission: getDeletePermission,
        });
      }
    });
  }

  addProfile() {
    this.props.navigate("/apProfileMgmnt", {
      state: {
        action: "create",
      },
    });
  }

  toProfileDetails(e, rowData) {
    let profileState = {
      initialPage: this.state.initialPage,
      pageSize: this.state.pageSize,
      profileId: rowData.id,
      selectedTab: this.state.selectedTab,
      searchText: this.state.searchText,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ profileState })
    );
    this.props.navigate("/apProfileMgmnt", {
      state: {
        action: "view",
        profileId: rowData.id,
        name: rowData.name,
        selectedTab: this.state.selectedTab,
      },
    });
  }
  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }
  handleSearchChange(searchText) {
    let profileState = {
      initialPage: this.state.initialPage,
      pageSize: this.state.pageSize,
      profileId: this.state.profileId,
      selectedTab: this.state.selectedTab,
      searchText: searchText,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ profileState })
    );
    this.setState({ searchText: searchText });
  }
  render() {
    if (this.state.render === false) {
      return <div />;
    }
    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          navigate={this.props.navigate}
          name={this.title}
          isSearchText={this.state.searchText !== ""}
        />
        <div style={{ maxWidth: "100%" }}>
          <MaterialTable
            title=""
            icons={UiUtils.getMaterialTableIcons("Add Role")}
            onRowClick={(event, rowData) => {
              this.toProfileDetails(event, rowData);
              event.stopPropagation();
            }}
            columns={[
              {
                title: "#",
                render: (rowData) => rowData.tableData.id + 1,
                width: "5%",
                align: "left",
                cellStyle: {
                  width: "6%",
                },
              },
              {
                title: "Profile",
                field: "name",
                cellStyle: {
                  width: "75%",
                },
              },
            ]}
            data={this.state.profileList}
            options={{
              sorting: true,
              actionsColumnIndex: -1,
              addRowPosition: "first",
              searchText: this.state.searchText,
              initialPage: this.state.initialPage,
              pageSize: this.state.pageSize,
              paging: this.state.isPaging,
              pageSizeOptions: Utils.materialTablePageSize(),
              headerStyle: {
                backgroundColor: "#37517e",
                fontWeight: "bold",
                color: "#ffff",
                align: "left",
              },
              rowStyle: (rowData) => ({
                backgroundColor:
                  rowData.id === this.state.profileId ? "#FEF5E7" : "",
                height: "3em",
                textTransform: "capitalize",
              }),
            }}
            onSearchChange={(searchText) => {
              this.handleSearchChange(searchText);
            }}
            onChangePage={(page, pageSize) => {
              this.handleMaterialTablePageChange(page, pageSize);
            }}
            actions={[
              {
                icon: () => <PtsButton btnName="Add Profile" type="submit" />,
                isFreeAction: true,
                onClick: (event) => this.addProfile(),
              },
            ]}
          />
        </div>
      </>
    );
  }
}
export default withRouter(ProfileManagementList);
